import { render, staticRenderFns } from "./KBC.vue?vue&type=template&id=03dd67fb&"
import script from "./KBC.vue?vue&type=script&lang=js&"
export * from "./KBC.vue?vue&type=script&lang=js&"
import style0 from "./KBC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports